// loomPlayer.js

/**
 * Initialize a single Loom player container.
 * @param {HTMLElement} parent - The `.loom-player` container element.
 */
export function initLoomPlayer(parent) {
  if (!parent || parent.dataset.loomPlayerInitialized === 'true') return;
  parent.dataset.loomPlayerInitialized = 'true';

  const iframe = parent.querySelector('iframe[data-src]');
  const button = parent.querySelector('.loom-player__button');

  if (!iframe) return;

  iframe.hidden = true;

  let loaded = false;
  let timeoutId = null;

  function hideButtonOnIframeLoad() {
    if (button) {
      button.hidden = true;
    }
    iframe.removeEventListener('load', hideButtonOnIframeLoad);
  }

  /**
   * Load the iframe, optionally enabling autoplay.
   * @param {boolean} autoplay - Whether to add `autoplay=1` to the iframe URL.
   */
  function loadIframe(autoplay = false) {
    if (loaded) return;
    loaded = true;
    iframe.hidden = false;

    if (timeoutId !== null) clearTimeout(timeoutId);
    parent.removeEventListener('click', onInteraction);
    if (button) button.removeEventListener('click', onInteraction);

    let src = iframe.dataset.src;
    if (src && !iframe.src) {
      if (autoplay) {
        // Add autoplay=1 if not already present
        if (!/[?&]autoplay=1(?:&|$)/.test(src)) {
          src += (src.includes('?') ? '&' : '?') + 'autoplay=1';
        }
      }

      iframe.addEventListener('load', hideButtonOnIframeLoad);
      iframe.src = src;
      delete iframe.dataset.src;
    } else {
      // Fallback if src is missing or already set
      if (button) {
        button.hidden = true;
      }
    }
  }

  function onInteraction(event) {
    event.preventDefault();
    // Load with autoplay on click/tap
    loadIframe(true);
  }

  // Lazy-load after N seconds
  timeoutId = window.setTimeout(() => loadIframe(false), 3000);

  // Click / tap on container or button
  parent.addEventListener('click', onInteraction);
  if (button) {
    button.addEventListener('click', onInteraction);
  }
}

/**
 * Initialize all Loom players matching a selector.
 * @param {string} selector - CSS selector for player containers.
 */
export function initAllLoomPlayers(selector = '.js-loom-player') {
  const players = document.querySelectorAll(selector);
  players.forEach((el) => initLoomPlayer(el));
}
